module.exports = __webpack_public_path__ + "static/img/5_1.9e8489a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/search/5_1.png
// module id = W52B
// module chunks = 1